import React from "react";
import styled from "styled-components";
import { Colors } from "../ColorConstants";
import loaderGif from "../assets/gifs/AlMaha_loading.gif";
import { ThreeDots } from "react-loader-spinner";

const CustomLoader = () => {
  return (
    <LoaderOverlay>
      <LoaderContent>
        <ThreeDots
          height="100"
          width="100"
          radius="9"
          color={Colors.aqua}
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClassName=""
          visible={true}
        />
      </LoaderContent>
    </LoaderOverlay>
  );
};

export default CustomLoader;

const LoaderOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const LoaderContent = styled.div`
  border-radius: 8px;
  padding: 20px;
`;
